export enum TypeUser {
    CUSTOMER ="Customer",
    EDITOR = "Editor",
    ADMIN = "Admin",

}